import React from 'react';
import { useGoodfyndSite } from '@features/goodfynd-sites/context/goodfynd-site-context';
import { Container } from '@goodfynd/layout';
import { FlexView, Logo, Text } from '@goodfynd/ui';
import { addClassNames } from 'theme';

import classes from './GoodfyndSitesFooter.module.css';

export function GoodfyndSitesFooter() {
  const { organization } = useGoodfyndSite();
  return (
    <div className={classes.footer}>
      <Container
        className={addClassNames(
          'page-container padded',
          classes['footer-container']
        )}
      >
        <FlexView align="center" gap={2}>
          <Logo
            height={32}
            src="https://res.cloudinary.com/foodease/image/upload/v1665830340/assets/pin.png"
            width={21}
          />
          <Text as="subhead1" inherit>
            Powered by Goodfynd
          </Text>
        </FlexView>

        <Text as="bottomNavItem">
          &copy;{new Date().getFullYear()} {organization.businessName}
        </Text>
      </Container>
    </div>
  );
}
